import React, { useContext } from "react";
import toast from "react-hot-toast";
import { AuthContext } from "../../Context/UseContext";
import { useDbUser } from "../../hooks/useUser";

const BookingModal = ({ booking, setBooking }) => {
  const { title, _id, resellerPrice, seller_id, seller_email } = booking;
  console.log(booking);
  const { user } = useContext(AuthContext);
  const [dbUser] = useDbUser(user?.email);

  const handleBooking = (event) => {
    event.preventDefault();
    const form = event.target;
    const name = form.name.value;
    const email = form.email.value;
    const price = form.price.value;
    const phone = form.phone.value;
    const location = form.location.value;

    const booking = {
      productID: _id,
      product: title,
      buyerName: name,
      email,
      price,
      phone,
      location,
      buyer_id: dbUser._id,
      seller_id: seller_id,
      seller_email: seller_email,
      booking_date: new Date().toISOString(),
    };

    fetch(`${process.env.REACT_APP_API_URL}/booking`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`
      },
      body: JSON.stringify(booking),
    })
      .then((res) => res.json())
      .then((data) => {

        if (data.acknowledged === true) {
          setBooking(null);
          toast.success("Booking confirmed");
        } else {
          toast.error(data.message);
        }
      });
  };


  return (
    <>
      <input type="checkbox" id="booking-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box relative">
          <label
            htmlFor="booking-modal"
            className="btn btn-sm btn-circle absolute right-2 top-2">
            ✕
          </label>
          <h3 className="text-lg font-bold">{title}</h3>
          <form
            onSubmit={handleBooking}
            className="grid grid-cols-1 gap-3 mt-10">
            <input
              type="text"
              placeholder="Product name"
              defaultValue={title}
              className="input w-full input-bordered "
              disabled
            />
            <input
              name="name"
              type="text"
              placeholder="Your Name"
              defaultValue={dbUser?.name}
              className="input w-full input-bordered"
              disabled
            />
            <input
              name="email"
              type="email"
              placeholder="Email Address"
              defaultValue={dbUser?.email}
              className="input w-full input-bordered"
              disabled
            />
            <input
              name="price"
              type="text"
              placeholder="price"
              className="input w-full input-bordered"
              defaultValue={resellerPrice}
              disabled
            />
            <input
              name="phone"
              type="number"
              placeholder="Enter Phone Number"
              className="input w-full input-bordered"
              required
            />
            <input
              name="location"
              type="text"
              placeholder="your Location"
              className="input w-full input-bordered"
              required
            />
            <br />
            <input
              className="btn btn-primary w-full"
              type="submit"
              value="Book Now"
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default BookingModal;
